import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as $7exkJ$useState, useMemo as $7exkJ$useMemo, useCallback as $7exkJ$useCallback } from "react";
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $e5614764aa47eb35$export$cfc51cf86138bf98(props, state) {
  var triggerKey = props.triggerKey;
  var expandedKeysStack = state.expandedKeysStack,
      openSubmenu = state.openSubmenu,
      closeSubmenu = state.closeSubmenu,
      closeAll = state.close;

  var _ref = (0, $7exkJ$useState)(expandedKeysStack === null || expandedKeysStack === void 0 ? void 0 : expandedKeysStack.length),
      _ref2 = _slicedToArray(_ref, 1),
      submenuLevel = _ref2[0];

  var isOpen = (0, $7exkJ$useMemo)(function () {
    return expandedKeysStack[submenuLevel] === triggerKey;
  }, [expandedKeysStack, triggerKey, submenuLevel]);

  var _ref3 = (0, $7exkJ$useState)(null),
      _ref4 = _slicedToArray(_ref3, 2),
      focusStrategy = _ref4[0],
      setFocusStrategy = _ref4[1];

  var open = (0, $7exkJ$useCallback)(function (focusStrategy) {
    setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
    openSubmenu(triggerKey, submenuLevel);
  }, [openSubmenu, submenuLevel, triggerKey]);
  var close = (0, $7exkJ$useCallback)(function () {
    setFocusStrategy(null);
    closeSubmenu(triggerKey, submenuLevel);
  }, [closeSubmenu, submenuLevel, triggerKey]);
  var toggle = (0, $7exkJ$useCallback)(function (focusStrategy) {
    setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
    if (isOpen) close();else open(focusStrategy);
  }, [close, open, isOpen]);
  return (0, $7exkJ$useMemo)(function () {
    return {
      focusStrategy: focusStrategy,
      isOpen: isOpen,
      open: open,
      close: close,
      closeAll: closeAll,
      submenuLevel: submenuLevel,
      // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
      // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
      setOpen: function setOpen() {},
      toggle: toggle
    };
  }, [isOpen, open, close, closeAll, focusStrategy, toggle, submenuLevel]);
}

export { $e5614764aa47eb35$export$cfc51cf86138bf98 as useSubmenuTriggerState };